// extracted by mini-css-extract-plugin
export default {"Panel":"AdminPanel_Panel__OSuh3","Body":"AdminPanel_Body__RQU3W","BackLink":"AdminPanel_BackLink__cL6Rn","Hint":"AdminPanel_Hint__qPMe0"};